module.exports = __webpack_public_path__ + "static/media/caja_madera_enrollador.f00902c5.jpg";